import { reportApiClient as apiClient } from './configs/AxiosClient'
import {
  Assessment as ReportAssesment,
  AssessmentReportData,
  CandidateReport,
  CandidateReport2,
} from './entities/report.entity'
import { Assessment } from './entities/assessment.entity'

export const ReportAPI = {
  getAssessment: async (
    candidateId: string,
  ): Promise<any> => {
    let url = `/candidates/${candidateId}/assessment`
    const response: any = await apiClient.get(url)
    return response.data
  },
  getAssessmentById: async (
    assessmentId: string,
  ): Promise<Assessment | undefined> => {
    let url = `/assessments/${assessmentId}?cache=0`
    const response: any = await apiClient.get(url)
    return response.data
  },

  getAssessments: async (): Promise<ReportAssesment[] | undefined> => {
    const response: any = await apiClient.get(`/assessments?cache=1`)
    return response.data
  },
  fetchReport: async (
    assessmentId: String,
  ): Promise<AssessmentReportData | undefined> => {
    const response: any = await apiClient.post(`/reports`, {
      assessmentId: assessmentId,
    })
    return response.data
  },
  fetchIndividualReport: async (
    candidateId: String,
  ): Promise<CandidateReport | undefined> => {
    const response: any = await apiClient.post(`/reports/candidate`, {
      candidateId: candidateId,
    })
    return response.data
  },
  fetchIndividualReport2: async (
    candidateId: String,
  ): Promise<CandidateReport2 | undefined> => {
    const response: any = await apiClient.post(`/v2/reports/candidate`, {
      candidateId: candidateId,
    })
    return response.data
  },
  fetchIndividualReport3: async (
    candidateId: String,
  ): Promise<any | undefined> => {
    const response: any = await apiClient.post(`/v3/reports/candidate`, {
      candidateId: candidateId,
    })
    return response.data
  },
}
